<template>
  <div class="editor-popup">
    <div class="editor-popup__content">
      <div class="editor-popup__close" @click="close" />

      <div class="editor-popup__content-type">
        <h3 class="editor-popup__title">Add Page</h3>
      </div>
      <div class="field">
        <label class="label">Open Graph Description</label>
        <input
          type="text"
          class="input input--outline"
          id="title"
          placeholder="_"
          v-model="title"
        />
      </div>
      <div class="field">
        <label class="label">Open Graph Image</label>
        <input
          type="text"
          class="input input--outline"
          id="author"
          placeholder="_"
          v-model="author"
        />
      </div>
      <div class="field">
        <label class="label">Page Title Suffix</label>
        <input
          type="text"
          class="input input--outline"
          id="description"
          placeholder="_"
          v-model="description"
        />
      </div>
      <div class="field">
        <label class="label">Page Title Suffix</label>
        <input
          type="text"
          class="input input--outline"
          id="description"
          placeholder="_"
          v-model="description"
        />
      </div>
      <div class="field">
        <label class="label">Meta Description</label>
        <textarea
          class="input input--outline"
          id="description"
          placeholder="_"
          v-model="description"
        />
      </div>
      <div class="field">
        <button class="button button--info button--fluid" @click="upload">save</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      type: "",
      title: "",
      author: "",
      description: "",
      file: null
    };
  },
  methods: {
    ...mapMutations(["closePopup"]),
    handleChangeType(type) {
      this.type = type;
    },
    onFileChange() {
      this.file = this.$refs.myFiles.files;
      console.log(this.file);
    },
    upload() {
      alert("uploadaing");
      this.closePopup("addPage");
    },
    close() {
      this.closePopup("addPage");
    }
  }
};
</script>

<style lang="scss" scoped>
.change-type {
  display: flex;
  margin-bottom: 40px;

  &__text {
    margin-bottom: 5px;
    font-size: 22px;
    color: #b8b8b8;
  }

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #bfbfbf;
    border-radius: 5px;
    width: 93px;
    height: 75px;
  }

  &__button {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    margin-right: 15px;

    &:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
